import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { isEmptyObject } from "@chakra-ui/utils";
/**
 * Check if a theme key refers to a components
 * or sub-component
 */

export function isSubcomponent(themeKey) {
  return themeKey.split(".").length > 1;
}
/**
 * Check if a style object is not empty
 */

export function isNotEmpty(value) {
  return value && !isEmptyObject(value);
}
export function filterUndefined(object) {
  var result = _extends({}, object);

  for (var item in result) {
    if (typeof result[item] === "undefined") {
      delete result[item];
    }
  }

  return result;
}